import { render, staticRenderFns } from "./DepositAddOn.vue?vue&type=template&id=f72cfce0&scoped=true&"
import script from "./DepositAddOn.vue?vue&type=script&lang=js&"
export * from "./DepositAddOn.vue?vue&type=script&lang=js&"
import style0 from "./DepositAddOn.vue?vue&type=style&index=0&id=f72cfce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72cfce0",
  null
  
)

export default component.exports